import React, { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getProject } from '../data/projects';
import { projectRegistry } from './projects/registry';

const ProjectDetailRoute: React.FC = () => {
  const { slug = '' } = useParams();
  const project = getProject(slug);
  const ProjectPage = projectRegistry[slug];

  if (!project || !ProjectPage) return <Navigate to="/" replace />;

  return (
    <Suspense fallback={<main aria-busy="true" aria-label="Loading project" style={{ minHeight: '100vh' }} />}>
      <ProjectPage project={project} />
    </Suspense>
  );
};

export default ProjectDetailRoute;
